import React, { useState, useRef, useEffect } from 'react';
import colors from '../../utils/colors';
import typography from '../../utils/typography';

// Icons
const PlaylistIcon = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.96292 12.788C1.43111 12.788 1 12.3497 1 11.8092V11.8092C1 11.2686 1.43111 10.8304 1.96292 10.8304H7.74042C8.27223 10.8304 8.70334 11.2686 8.70334 11.8092V11.8092C8.70334 12.3497 8.27223 12.788 7.74042 12.788H1.96292ZM1.96292 8.87278C1.43111 8.87278 1 8.43456 1 7.89398V7.89398C1 7.35341 1.43111 6.91519 1.96292 6.91519H11.5921C12.1239 6.91519 12.555 7.35341 12.555 7.89398V7.89398C12.555 8.43456 12.1239 8.87278 11.5921 8.87278H1.96292ZM1.96292 4.95759C1.43111 4.95759 1 4.51937 1 3.9788V3.9788C1 3.43822 1.43111 3 1.96292 3H11.5921C12.1239 3 12.555 3.43822 12.555 3.9788V3.9788C12.555 4.51937 12.1239 4.95759 11.5921 4.95759H1.96292ZM15.015 16.6675C14.3751 17.1011 13.5179 16.6348 13.5179 15.8531V11.6805C13.5179 10.8987 14.3751 10.4324 15.015 10.8661L18.0936 12.9524C18.6654 13.3398 18.6654 14.1937 18.0936 14.5812L15.015 16.6675Z" fill="#BAB4B1"/>
  </svg>
);

const ThumbsUpIcon = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.8254 6.62392C17.2275 6.62392 17.5794 6.77842 17.881 7.08742C18.1825 7.39642 18.3333 7.75693 18.3333 8.16893V9.71394C18.3333 9.80407 18.3239 9.90063 18.3051 10.0036C18.2862 10.1066 18.2579 10.2032 18.2202 10.2933L15.9583 15.7395C15.8452 15.997 15.6567 16.2159 15.3929 16.3961C15.129 16.5764 14.8525 16.6665 14.5635 16.6665H8.53175C8.11706 16.6665 7.76207 16.5152 7.46677 16.2127C7.17146 15.9101 7.02381 15.5464 7.02381 15.1215V7.26123C7.02381 7.05523 7.06465 6.85889 7.14633 6.6722C7.22801 6.48551 7.33796 6.32135 7.47619 6.17973L11.5665 2.00819C11.755 1.82794 11.978 1.7185 12.2356 1.67987C12.4932 1.64125 12.7414 1.68631 12.9802 1.81506C13.2189 1.94381 13.3917 2.12407 13.4985 2.35582C13.6053 2.58757 13.6273 2.82576 13.5645 3.07039L12.7163 6.62392H16.8254ZM4.00794 16.6665C3.59325 16.6665 3.23826 16.5152 2.94296 16.2127C2.64765 15.9101 2.5 15.5464 2.5 15.1215V8.16893C2.5 7.74405 2.64765 7.38033 2.94296 7.07776C3.23826 6.7752 3.59325 6.62392 4.00794 6.62392C4.42262 6.62392 4.77761 6.7752 5.07292 7.07776C5.36822 7.38033 5.51587 7.74405 5.51587 8.16893V15.1215C5.51587 15.5464 5.36822 15.9101 5.07292 16.2127C4.77761 16.5152 4.42262 16.6665 4.00794 16.6665Z" fill="#BAB4B1"/>
  </svg>
);

const ThumbsDownIcon = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.26571 13.0932C3.90592 13.0932 3.59111 12.9559 3.32127 12.6812C3.05142 12.4066 2.9165 12.0861 2.9165 11.7199V10.3466C2.9165 10.2664 2.92494 10.1806 2.9418 10.0891C2.95867 9.9975 2.98396 9.91166 3.01769 9.83155L5.0415 4.99051C5.14269 4.76162 5.31135 4.56706 5.54746 4.40684C5.78357 4.24662 6.03092 4.1665 6.28952 4.1665H11.6863C12.0574 4.1665 12.375 4.30098 12.6392 4.56992C12.9034 4.83887 13.0356 5.16218 13.0356 5.53985V12.5267C13.0356 12.7099 12.999 12.8844 12.9259 13.0503C12.8528 13.2163 12.7545 13.3622 12.6308 13.4881L8.97107 17.1961C8.80242 17.3563 8.60285 17.4536 8.37236 17.488C8.14187 17.5223 7.91981 17.4822 7.70619 17.3678C7.49256 17.2533 7.33797 17.0931 7.2424 16.8871C7.14683 16.6811 7.12715 16.4694 7.18337 16.2519L7.9423 13.0932H4.26571ZM15.734 4.1665C16.105 4.1665 16.4226 4.30098 16.6868 4.56992C16.9511 4.83887 17.0832 5.16218 17.0832 5.53985V11.7199C17.0832 12.0976 16.9511 12.4209 16.6868 12.6898C16.4226 12.9588 16.105 13.0932 15.734 13.0932C15.3629 13.0932 15.0453 12.9588 14.7811 12.6898C14.5169 12.4209 14.3848 12.0976 14.3848 11.7199V5.53985C14.3848 5.16218 14.5169 4.83887 14.7811 4.56992C15.0453 4.30098 15.3629 4.1665 15.734 4.1665Z" fill="#BAB4B1"/>
  </svg>
);

const CommentIcon = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M17.4999 9.42725C17.4999 12.7927 14.142 15.521 9.9999 15.521C9.23061 15.521 8.48838 15.4269 7.78969 15.2521C7.58226 15.2002 7.36229 15.2198 7.17234 15.318L3.44661 17.2434C2.7003 17.629 1.91686 16.7932 2.35001 16.0734L3.76133 13.7281C3.95573 13.405 3.90397 12.9953 3.67122 12.6987C2.92961 11.7536 2.4999 10.6312 2.4999 9.42725C2.4999 6.06176 5.85776 3.3335 9.9999 3.3335C14.142 3.3335 17.4999 6.06176 17.4999 9.42725ZM7.49989 10.2502C7.96013 10.2502 8.33323 9.87706 8.33323 9.41682C8.33323 8.95658 7.96013 8.58349 7.49989 8.58349C7.03966 8.58349 6.66656 8.95658 6.66656 9.41682C6.66656 9.87706 7.03966 10.2502 7.49989 10.2502ZM9.99989 10.2502C10.4601 10.2502 10.8332 9.87706 10.8332 9.41682C10.8332 8.95658 10.4601 8.58349 9.99989 8.58349C9.53966 8.58349 9.16656 8.95658 9.16656 9.41682C9.16656 9.87706 9.53966 10.2502 9.99989 10.2502ZM13.3332 9.41682C13.3332 9.87706 12.9601 10.2502 12.4999 10.2502C12.0397 10.2502 11.6666 9.87706 11.6666 9.41682C11.6666 8.95658 12.0397 8.58349 12.4999 8.58349C12.9601 8.58349 13.3332 8.95658 13.3332 9.41682Z" fill="#BAB4B1"/>
  </svg>
);

const ShareIcon = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.8334 3.3669C10.8334 2.574 11.8112 2.19878 12.3416 2.78814L18.0989 9.18514C18.3951 9.51416 18.3951 10.0136 18.0989 10.3427L12.3416 16.7397C11.8112 17.329 10.8334 16.9538 10.8334 16.1609V13.2245C7.69898 13.2247 5.44699 14.5857 3.55943 16.0192C3.00037 16.4437 2.20359 16.0804 2.25212 15.3801C2.68151 9.18365 7.6471 6.25041 10.8334 6.25V3.3669Z" fill="#BAB4B1"/>
  </svg>
);

const MoreIcon = () => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.99967 11.6663C4.54134 11.6663 4.14898 11.5031 3.82259 11.1768C3.4962 10.8504 3.33301 10.458 3.33301 9.99967C3.33301 9.54134 3.4962 9.14898 3.82259 8.82259C4.14898 8.4962 4.54134 8.33301 4.99967 8.33301C5.45801 8.33301 5.85037 8.4962 6.17676 8.82259C6.50315 9.14898 6.66634 9.54134 6.66634 9.99967C6.66634 10.458 6.50315 10.8504 6.17676 11.1768C5.85037 11.5031 5.45801 11.6663 4.99967 11.6663ZM9.99967 11.6663C9.54134 11.6663 9.14898 11.5031 8.82259 11.1768C8.4962 10.8504 8.33301 10.458 8.33301 9.99967C8.33301 9.54134 8.4962 9.14898 8.82259 8.82259C9.14898 8.4962 9.54134 8.33301 9.99967 8.33301C10.458 8.33301 10.8504 8.4962 11.1768 8.82259C11.5031 9.14898 11.6663 9.54134 11.6663 9.99967C11.6663 10.458 11.5031 10.8504 11.1768 11.1768C10.8504 11.5031 10.458 11.6663 9.99967 11.6663ZM14.9997 11.6663C14.5413 11.6663 14.149 11.5031 13.8226 11.1768C13.4962 10.8504 13.333 10.458 13.333 9.99967C13.333 9.54134 13.4962 9.14898 13.8226 8.82259C14.149 8.4962 14.5413 8.33301 14.9997 8.33301C15.458 8.33301 15.8504 8.4962 16.1768 8.82259C16.5031 9.14898 16.6663 9.54134 16.6663 9.99967C16.6663 10.458 16.5031 10.8504 16.1768 11.1768C15.8504 11.5031 15.458 11.6663 14.9997 11.6663Z" fill="#BAB4B1"/>
  </svg>
);

const VolumeIcon = ({ isMuted }) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    {isMuted ? (
      <>
        {/* Muted volume icon - speaker only */}
        <path d="M9.28334 3.61181L5.95001 6.94514C5.87501 7.02014 5.76667 7.07014 5.65833 7.07014H3.33333C2.875 7.07014 2.5 7.44514 2.5 7.90348V11.2368C2.5 11.6951 2.875 12.0701 3.33333 12.0701H5.65833C5.76667 12.0701 5.87501 12.1118 5.95001 12.1951L9.28334 15.5285C9.55001 15.7868 9.99167 15.6035 9.99167 15.2368V3.90348C9.99167 3.52848 9.54167 3.34514 9.28334 3.61181Z" fill="currentColor"/>
        {/* X mark for muted */}
        <path d="M13.5 6.5L16.5 9.5M16.5 6.5L13.5 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </>
    ) : (
      <>
        {/* Normal volume icon */}
        <path d="M12.6667 2.54514C13.9417 3.01181 15.0083 3.78681 15.875 4.87014V4.88681C16.9583 6.23681 17.5 7.80348 17.5 9.56181C17.5 11.3201 16.9583 12.8868 15.875 14.2368C15.0083 15.3201 13.9417 16.0951 12.6667 16.5618C12.1667 16.7451 11.6667 16.3451 11.6667 15.8118V15.7701C11.6667 15.3951 11.9167 15.0785 12.2583 14.9368C13.2333 14.5368 14.0417 13.9118 14.6833 13.0535C15.45 12.0285 15.8333 10.8618 15.8333 9.55348C15.8333 8.24514 15.45 7.07848 14.6833 6.05348C14.05 5.18681 13.2417 4.56181 12.2583 4.17014C11.9167 4.02848 11.6667 3.71181 11.6667 3.33681V3.29514C11.6667 2.76181 12.1667 2.36181 12.6667 2.54514Z" fill="currentColor"/>
        <path d="M9.28334 3.61181L5.95001 6.94514C5.87501 7.02014 5.76667 7.07014 5.65833 7.07014H3.33333C2.875 7.07014 2.5 7.44514 2.5 7.90348V11.2368C2.5 11.6951 2.875 12.0701 3.33333 12.0701H5.65833C5.76667 12.0701 5.87501 12.1118 5.95001 12.1951L9.28334 15.5285C9.55001 15.7868 9.99167 15.6035 9.99167 15.2368V3.90348C9.99167 3.52848 9.54167 3.34514 9.28334 3.61181Z" fill="currentColor"/>
        <path d="M12.2333 12.5701C12.625 12.2951 12.9417 11.9535 13.2 11.5368C13.5667 10.9368 13.75 10.2785 13.75 9.57014C13.75 8.86181 13.5667 8.17847 13.2 7.57014C12.95 7.14514 12.625 6.80347 12.2333 6.52014C11.9833 6.34514 11.6667 6.54514 11.6667 6.84514V12.2451C11.6667 12.5535 11.9833 12.7451 12.2333 12.5701Z" fill="currentColor"/>
      </>
    )}
  </svg>
);

const RepeatIcon = () => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.6997 9.27774C10.96 9.01761 11.3818 9.01761 11.6421 9.27774L12.9614 10.5961C13.3516 10.9866 13.3516 11.6207 12.9614 12.0111L11.6421 13.3295C11.3818 13.5894 10.96 13.5895 10.6997 13.3295C10.4394 13.0692 10.4396 12.6465 10.6997 12.3861L11.1333 11.9516C10.0352 11.8554 9.01826 11.3749 8.25146 10.6137L8.88623 9.31973C9.41775 10.0192 10.2074 10.4815 11.0815 10.6029L10.6997 10.2211C10.4394 9.96082 10.4396 9.53811 10.6997 9.27774ZM10.6997 2.74454C10.96 2.48424 11.3817 2.48424 11.6421 2.74454L12.9614 4.0629C13.3515 4.45332 13.3515 5.08651 12.9614 5.47696L11.6421 6.7963C11.3818 7.05621 10.96 7.05621 10.6997 6.7963C10.4394 6.53596 10.4394 6.11329 10.6997 5.85294L11.0825 5.46817C10.0037 5.61726 9.05381 6.2884 8.55811 7.2797L7.47119 9.45157C6.68069 11.0324 5.06484 12.0316 3.29736 12.0316H3.02197C2.65381 12.0316 2.35503 11.7328 2.35498 11.3647C2.35502 10.9965 2.65381 10.6977 3.02197 10.6977H3.29736C4.55985 10.6976 5.71418 9.98408 6.27881 8.85489L7.36475 6.68302C8.0944 5.22382 9.52795 4.26218 11.1343 4.12247L10.6997 3.6879C10.4394 3.42756 10.4394 3.00489 10.6997 2.74454ZM3.29736 4.04239C4.59287 4.04244 5.80514 4.58048 6.67236 5.48966L6.02881 6.80118C5.41133 5.91698 4.39588 5.37643 3.29736 5.37638H3.02197C2.65405 5.37629 2.35529 5.07726 2.35498 4.70938C2.35498 4.34125 2.65386 4.04248 3.02197 4.04239H3.29736Z" fill="#726E6C"/>
  </svg>
);

const PrevIcon = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 17V7C8 6.71667 7.90417 6.47917 7.7125 6.2875C7.52083 6.09583 7.28333 6 7 6C6.71667 6 6.47917 6.09583 6.2875 6.2875C6.09583 6.47917 6 6.71667 6 7V17C6 17.2833 6.09583 17.5208 6.2875 17.7125C6.47917 17.9042 6.71667 18 7 18C7.28333 18 7.52083 17.9042 7.7125 17.7125C7.90417 17.5208 8 17.2833 8 17ZM19 16.125V7.875C19 7.575 18.9 7.33333 18.7 7.15C18.5 6.96667 18.2667 6.875 18 6.875C17.9167 6.875 17.825 6.88333 17.725 6.9C17.625 6.91667 17.5333 6.95833 17.45 7.025L11.25 11.175C11.1 11.275 10.9875 11.3958 10.9125 11.5375C10.8375 11.6792 10.8 11.8333 10.8 12C10.8 12.1667 10.8375 12.3208 10.9125 12.4625C10.9875 12.6042 11.1 12.725 11.25 12.825L17.45 16.975C17.5333 17.0417 17.625 17.0833 17.725 17.1C17.825 17.1167 17.9167 17.125 18 17.125C18.2667 17.125 18.5 17.0333 18.7 16.85C18.9 16.6667 19 16.425 19 16.125Z" fill="#FAF7F5"/>
  </svg>
);

const PlayPauseIcon = ({ isPlaying }) => (
  <svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <mask id="playPauseMask">
        {/* White circle allows everything through */}
        <circle cx={20} cy={20} r={20} fill="white" />
        {/* Black icons create knockouts with subtle corner radius */}
        {isPlaying ? (
          <>
            <rect x={15} y={13} width={3} height={14} rx={1.5} ry={1.5} fill="black" />
            <rect x={22} y={13} width={3} height={14} rx={1.5} ry={1.5} fill="black" />
          </>
        ) : (
          <path d="M16 12 C16 12 16 12 16.5 12.3 L25.5 19.7 C26 20 26 20 25.5 20.3 L16.5 27.7 C16 28 16 28 16 28 Z" fill="black" />
        )}
      </mask>
    </defs>
    {/* White circle with mask applied to create knockouts */}
    <circle cx={20} cy={20} r={20} fill="#FAF7F5" mask="url(#playPauseMask)" />
  </svg>
);

const NextIcon = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5 17V7C16.5 6.71667 16.5958 6.47917 16.7875 6.2875C16.9792 6.09583 17.2167 6 17.5 6C17.7833 6 18.0208 6.09583 18.2125 6.2875C18.4042 6.47917 18.5 6.71667 18.5 7V17C18.5 17.2833 18.4042 17.5208 18.2125 17.7125C18.0208 17.9042 17.7833 18 17.5 18C17.2167 18 16.9792 17.9042 16.7875 17.7125C16.5958 17.5208 16.5 17.2833 16.5 17ZM5.5 16.125V7.875C5.5 7.575 5.6 7.33333 5.8 7.15C6 6.96667 6.23333 6.875 6.5 6.875C6.58333 6.875 6.675 6.88333 6.775 6.9C6.875 6.91667 6.96667 6.95833 7.05 7.025L13.25 11.175C13.4 11.275 13.5125 11.3958 13.5875 11.5375C13.6625 11.6792 13.7 11.8333 13.7 12C13.7 12.1667 13.6625 12.3208 13.5875 12.4625C13.5125 12.6042 13.4 12.725 13.25 12.825L7.05 16.975C6.96667 17.0417 6.875 17.0833 6.775 17.1C6.675 17.1167 6.58333 17.125 6.5 17.125C6.23333 17.125 6 17.0333 5.8 16.85C5.6 16.6667 5.5 16.425 5.5 16.125Z" fill="#FAF7F5"/>
  </svg>
);

const ShuffleIcon = () => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.4335 4.66651H4.66683V6.66651C4.66683 6.8554 4.60294 7.01373 4.47516 7.14151C4.34739 7.26929 4.18905 7.33318 4.00016 7.33318C3.81127 7.33318 3.65294 7.26929 3.52516 7.14151C3.39739 7.01373 3.3335 6.8554 3.3335 6.66651V4.66651C3.3335 4.29984 3.46405 3.98596 3.72516 3.72484C3.98627 3.46373 4.30016 3.33318 4.66683 3.33318H11.4335L10.8668 2.76651C10.7335 2.63318 10.6696 2.47762 10.6752 2.29985C10.6807 2.12207 10.7446 1.96651 10.8668 1.83318C11.0002 1.69985 11.1585 1.6304 11.3418 1.62485C11.5252 1.61929 11.6835 1.68318 11.8168 1.81651L13.5335 3.53318C13.6002 3.59984 13.6474 3.67207 13.6752 3.74984C13.7029 3.82762 13.7168 3.91096 13.7168 3.99984C13.7168 4.08873 13.7029 4.17207 13.6752 4.24984C13.6474 4.32762 13.6002 4.39984 13.5335 4.46651L11.8168 6.18318C11.6835 6.31651 11.5252 6.3804 11.3418 6.37484C11.1585 6.36929 11.0002 6.29984 10.8668 6.16651C10.7446 6.03318 10.6807 5.87762 10.6752 5.69984C10.6696 5.52207 10.7335 5.36651 10.8668 5.23318L11.4335 4.66651Z" fill="#726E6C"/>
    <path d="M4.56654 12.6665L5.1332 13.2332C5.26654 13.3665 5.33043 13.5221 5.32487 13.6998C5.31931 13.8776 5.25543 14.0332 5.1332 14.1665C4.99987 14.2998 4.84154 14.3693 4.6582 14.3748C4.47487 14.3804 4.31654 14.3165 4.1832 14.1832L2.46654 12.4665C2.39987 12.3998 2.35265 12.3276 2.32487 12.2498C2.29709 12.1721 2.2832 12.0887 2.2832 11.9998C2.2832 11.9109 2.29709 11.8276 2.32487 11.7498C2.35265 11.6721 2.39987 11.5998 2.46654 11.5332L4.1832 9.8165C4.31654 9.68317 4.47487 9.61928 4.6582 9.62484C4.84154 9.63039 4.99987 9.69984 5.1332 9.83317C5.25543 9.9665 5.31931 10.1221 5.32487 10.2998C5.33043 10.4776 5.26654 10.6332 5.1332 10.7665L4.56654 11.3332H11.3332V9.33317C11.3332 9.14428 11.3971 8.98595 11.5249 8.85817C11.6526 8.73039 11.811 8.6665 11.9999 8.6665C12.1888 8.6665 12.3471 8.73039 12.4749 8.85817C12.6026 8.98595 12.6665 9.14428 12.6665 9.33317V11.3332C12.6665 11.6998 12.536 12.0137 12.2749 12.2748C12.0138 12.5359 11.6999 12.6665 11.3332 12.6665H4.56654Z" fill="#726E6C"/>
  </svg>
);

const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

const Playbar = ({ 
  song, 
  isPlaying = false, 
  onPlayPause, 
  onNext, 
  onPrev,
  onClose 
}) => {
  const [currentTime, setCurrentTime] = useState(30); // Mock current time
  const [duration] = useState(272); // Mock duration (4:32)
  const [isDragging, setIsDragging] = useState(false);
  const [volume, setVolume] = useState(70); // Volume percentage
  const [showVolumeSlider, setShowVolumeSlider] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [previousVolume, setPreviousVolume] = useState(70);
  const [hoveredSection, setHoveredSection] = useState(null);
  const [showSectionTooltip, setShowSectionTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState(0);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [useMousePosition, setUseMousePosition] = useState(false);
  const tooltipTimeoutRef = useRef(null);
  const progressRef = useRef(null);
  const volumeSliderRef = useRef(null);

  // Song sections with timestamps and labels
  const songSections = [
    { time: 20, percentage: (20 / 272) * 100, label: 'Intro' },
    { time: 68, percentage: (68 / 272) * 100, label: 'Verse 1' },
    { time: 136, percentage: (136 / 272) * 100, label: 'Chorus' },
    { time: 204, percentage: (204 / 272) * 100, label: 'Verse 2' },
    { time: 240, percentage: (240 / 272) * 100, label: 'Outro' },
    { time: 272, percentage: 100, label: 'End' }
  ];

  // Calculate progress percentage
  const progressPercentage = (currentTime / duration) * 100;

  // Mute/unmute handler
  const handleMuteToggle = () => {
    if (isMuted) {
      setVolume(previousVolume);
      setIsMuted(false);
    } else {
      setPreviousVolume(volume);
      setVolume(0);
      setIsMuted(true);
    }
  };

  // Volume slider handlers
  const updateVolumeFromMouse = (mouseY) => {
    if (!volumeSliderRef.current) return;
    
    const sliderRect = volumeSliderRef.current.getBoundingClientRect();
    const relativeY = mouseY - sliderRect.top;
    const sliderHeight = sliderRect.height;
    const newVolume = Math.max(0, Math.min(100, 100 - (relativeY / sliderHeight) * 100));
    setVolume(newVolume);
    
    // Unmute if volume is adjusted
    if (newVolume > 0 && isMuted) {
      setIsMuted(false);
    }
  };

  const handleVolumeMouseDown = (e) => {
    e.preventDefault();
    updateVolumeFromMouse(e.clientY);
    
    const handleVolumeDrag = (e) => {
      updateVolumeFromMouse(e.clientY);
    };
    
    const handleVolumeMouseUp = () => {
      document.removeEventListener('mousemove', handleVolumeDrag);
      document.removeEventListener('mouseup', handleVolumeMouseUp);
    };
    
    document.addEventListener('mousemove', handleVolumeDrag);
    document.addEventListener('mouseup', handleVolumeMouseUp);
  };

  // Handle scrubber interaction
  const handleMouseDown = (e) => {
    setIsDragging(true);
    handleScrub(e);
  };

  const handleSegmentClick = (sectionIndex, e) => {
    e.stopPropagation(); // Prevent the main progress bar click
    const targetTime = sectionIndex === 0 ? 0 : songSections[sectionIndex - 1].time;
    setCurrentTime(targetTime);
  };

  const handleSegmentHover = (sectionIndex, e) => {
    if (!isDragging) {
      const section = songSections[sectionIndex];
      setHoveredSection(section);
      
      // Get mouse position relative to the progress bar container
      if (progressRef.current) {
        const rect = progressRef.current.getBoundingClientRect();
        const relativeX = e.clientX - rect.left;
        const percentage = (relativeX / rect.width) * 100;
        setTooltipPosition(percentage);
      }
      
      setUseMousePosition(false); // Use percentage positioning for hover
      setShowSectionTooltip(true);
      
      // Clear any existing timeout
      if (tooltipTimeoutRef.current) {
        clearTimeout(tooltipTimeoutRef.current);
      }
    }
  };

  const handleSegmentMouseMove = (sectionIndex, e) => {
    if (!isDragging && showSectionTooltip) {
      // Update tooltip position to follow mouse
      if (progressRef.current) {
        const rect = progressRef.current.getBoundingClientRect();
        const relativeX = e.clientX - rect.left;
        const percentage = (relativeX / rect.width) * 100;
        setTooltipPosition(percentage);
      }
    }
  };

  const handleSegmentLeave = () => {
    if (!isDragging) {
      // Clear any existing timeout
      if (tooltipTimeoutRef.current) {
        clearTimeout(tooltipTimeoutRef.current);
      }
      // Delay hiding the tooltip by 300ms
      tooltipTimeoutRef.current = setTimeout(() => {
        setShowSectionTooltip(false);
      }, 300);
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      handleScrub(e);
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    // Clear any existing timeout
    if (tooltipTimeoutRef.current) {
      clearTimeout(tooltipTimeoutRef.current);
    }
    // Delay hiding the tooltip by 1200ms after stopping drag
    tooltipTimeoutRef.current = setTimeout(() => {
      setShowSectionTooltip(false);
    }, 1200);
  };

  const handleScrub = (e) => {
    if (progressRef.current) {
      const rect = progressRef.current.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const newProgress = Math.max(0, Math.min(1, clickX / rect.width));
      const newTime = newProgress * duration;
      setCurrentTime(newTime);

      // Check if we're near any section and show tooltip
      if (isDragging) {
        const tolerance = 10; // pixels
        const hoveredSection = songSections.find(section => {
          const sectionX = (section.percentage / 100) * rect.width;
          return Math.abs(clickX - sectionX) <= tolerance;
        });
        
        // Set tooltip position based on current progress percentage
        setTooltipPosition(newProgress * 100);
        
        if (hoveredSection) {
          // Clear any existing timeout
          if (tooltipTimeoutRef.current) {
            clearTimeout(tooltipTimeoutRef.current);
          }
          setHoveredSection(hoveredSection);
          setShowSectionTooltip(true);
        } else {
          // Clear any existing timeout
          if (tooltipTimeoutRef.current) {
            clearTimeout(tooltipTimeoutRef.current);
          }
          // Delay hiding the tooltip by 800ms
          tooltipTimeoutRef.current = setTimeout(() => {
            setShowSectionTooltip(false);
          }, 800);
        }
      }
    }
  };

  // Add global mouse event listeners
  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };
    }
  }, [isDragging]);

  // Reset current time when song changes
  useEffect(() => {
    setCurrentTime(0);
  }, [song?.id]);

  // Auto-advance progress when playing
  useEffect(() => {
    let interval;
    if (isPlaying && !isDragging) {
      interval = setInterval(() => {
        setCurrentTime(prev => {
          const newTime = prev + 1;
          // Reset to beginning when song ends
          if (newTime >= duration) {
            return 0;
          }
          return newTime;
        });
      }, 1000); // Update every second
    }
    
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isPlaying, isDragging, duration]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (tooltipTimeoutRef.current) {
        clearTimeout(tooltipTimeoutRef.current);
      }
    };
  }, []);

  if (!song) return null;

  return (
    <div className="relative h-[84px]">
      {/* Background layer - clipped to playbar bounds */}
      <div className="absolute inset-0 border-t overflow-hidden" style={{ backgroundColor: colors.bg.primary, borderTopColor: 'rgba(60, 54, 54, 0.5)' }}>
        {/* Blurred artwork overlay - contained within this clipped container */}
        <div 
          className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: song.image ? `url(${song.image})` : 'none',
            filter: 'blur(40px)',
            transform: 'scale(1.1)', // Slightly scale up to avoid blur edge artifacts
            opacity: 0.15
          }}
        />
      </div>
      
      {/* Content layer - not clipped, allows volume slider to extend outside */}
      <div className="relative z-10 h-full grid grid-cols-3 items-center pr-6">
        {/* Left section - Song info */}
        <div className="flex items-center gap-2.5 min-w-0 pl-6">
          <img 
            src={song.image} 
            alt={song.title}
            className="w-9 h-12 rounded-md object-cover flex-shrink-0"
          />
          <div className="flex flex-col justify-center min-w-0 flex-1">
            <p className="text-sm font-medium text-left text-[#faf7f5] truncate">
              {song.title}
            </p>
            <p className="text-xs font-medium text-left text-[#726e6c] truncate">
              {song.artist || 'DanielMusic'}
            </p>
          </div>
        </div>

        {/* Center section - Controls and progress */}
        <div className="flex flex-col items-center gap-1.5 w-full max-w-[1600px] xl:max-w-[1400px] lg:max-w-[1200px] md:max-w-[1000px] sm:max-w-[400px] mx-auto px-4 md:px-8">
          {/* Control buttons */}
          <div className="flex items-center gap-[35px]">
            <button className="text-[#726e6c] hover:text-[#faf7f5] transition-colors">
              <RepeatIcon />
            </button>
            <button 
              onClick={onPrev}
              className="text-[#faf7f5] hover:opacity-80 transition-opacity"
            >
              <PrevIcon />
            </button>
            <button 
              onClick={onPlayPause}
              className="hover:scale-105 transition-transform"
            >
              <PlayPauseIcon isPlaying={isPlaying} />
            </button>
            <button 
              onClick={onNext}
              className="text-[#faf7f5] hover:opacity-80 transition-opacity"
            >
              <NextIcon />
            </button>
            <button className="text-[#726e6c] hover:text-[#faf7f5] transition-colors">
              <ShuffleIcon />
            </button>
          </div>

          {/* Progress bar */}
          <div className="flex items-center gap-2.5 w-full min-w-[400px] lg:min-w-[600px] xl:min-w-[800px]">
            <span className="text-[#726e6c] w-[31px] text-right" style={typography.duration}>
              {formatTime(currentTime)}
            </span>
            
            <div className="flex-1 relative">
              {/* Segmented progress bar */}
              <div 
                ref={progressRef}
                className={`flex gap-0.5 cursor-pointer ${
                  isDragging ? 'h-[10px]' : 'h-1'
                }`}
                style={{ transition: 'height 200ms ease' }}
                onMouseDown={handleMouseDown}
              >
                {songSections.map((section, index) => {
                  const isFirstSection = index === 0;
                  const isLastSection = index === songSections.length - 1;
                  const prevPercentage = index === 0 ? 0 : songSections[index - 1].percentage;
                  const sectionWidth = section.percentage - prevPercentage;
                  const sectionProgress = Math.max(0, Math.min(100, ((progressPercentage - prevPercentage) / sectionWidth) * 100));
                  const isSectionActive = progressPercentage >= prevPercentage;
                  
                  // Determine border radius classes
                  const backgroundRadius = isFirstSection && isLastSection ? 'rounded-full' :
                                         isFirstSection ? 'rounded-l-full' :
                                         isLastSection ? 'rounded-r-full' : '';
                  
                  const fillRadius = isFirstSection && isLastSection ? 'rounded-full' :
                                   isFirstSection ? 'rounded-l-full' :
                                   isLastSection ? 'rounded-r-full' : '';
                  
                  return (
                    <div
                      key={index}
                      className={`relative bg-white/10 ${backgroundRadius} ${
                        isDragging ? 'h-[10px]' : 'h-1'
                      } cursor-pointer hover:bg-white/15 transition-colors`}
                      style={{ 
                        width: `${sectionWidth}%`,
                        transition: 'height 200ms ease'
                      }}
                      onClick={(e) => handleSegmentClick(index, e)}
                      onMouseEnter={(e) => handleSegmentHover(index, e)}
                      onMouseMove={(e) => handleSegmentMouseMove(index, e)}
                      onMouseLeave={handleSegmentLeave}
                    >
                      {/* Section progress fill */}
                      <div
                        className={`bg-[#faf7f5] ${fillRadius} ${
                          isDragging ? 'h-[10px]' : 'h-1'
                        }`}
                        style={{
                          width: isSectionActive ? `${sectionProgress}%` : '0%',
                          transition: 'height 200ms ease'
                        }}
                      />
                    </div>
                  );
                })}
                
                {/* Scrubber handle - positioned absolutely over the segments */}
                <div 
                  className="absolute top-1/2 w-3 h-3 bg-[#faf7f5] rounded-full border-2 cursor-grab -translate-y-1/2 transition-transform duration-200"
                  style={{ 
                    borderColor: colors.bg.primary,
                    left: `${progressPercentage}%`,
                    transform: `translate(-50%, -50%) ${isDragging ? 'scale(1.67)' : 'scale(1)'}`
                  }}
                  onMouseDown={handleMouseDown}
                />

                {/* Section tooltip */}
                {showSectionTooltip && hoveredSection && (
                  <div 
                    className="absolute bg-[#252020] text-[#faf7f5] text-xs px-2 py-1 rounded-md whitespace-nowrap z-50"
                    style={{
                      left: `${tooltipPosition}%`,
                      bottom: '20px',
                      transform: 'translateX(-50%)'
                    }}
                  >
                    {hoveredSection.label}
                  </div>
                )}
              </div>
            </div>

            <span className="text-[#726e6c] w-[31px] text-left" style={typography.duration}>
              {formatTime(duration)}
            </span>
          </div>
        </div>

        {/* Right section - Actions */}
        <div className="flex items-center gap-4 justify-end">
          <button className="text-[#bab4b1] hover:text-[#faf7f5] transition-colors">
            <PlaylistIcon />
          </button>
          <button className="text-[#bab4b1] hover:text-[#faf7f5] transition-colors">
            <ThumbsUpIcon />
          </button>
          <button className="text-[#bab4b1] hover:text-[#faf7f5] transition-colors">
            <ThumbsDownIcon />
          </button>
          <button className="text-[#bab4b1] hover:text-[#faf7f5] transition-colors">
            <CommentIcon />
          </button>
          <button className="text-[#bab4b1] hover:text-[#faf7f5] transition-colors">
            <ShareIcon />
          </button>
          <button className="text-[#bab4b1] hover:text-[#faf7f5] transition-colors">
            <MoreIcon />
          </button>
          <div 
            className="relative"
            onMouseEnter={() => setShowVolumeSlider(true)}
            onMouseLeave={() => setShowVolumeSlider(false)}
          >
            {/* Volume button */}
            <button 
              className="text-[#d1cbc7] hover:text-[#faf7f5] transition-colors"
              onClick={handleMuteToggle}
            >
              <VolumeIcon isMuted={isMuted} />
            </button>
            
            {/* Volume slider positioned above the icon */}
            {showVolumeSlider && (
              <div 
                className="absolute left-1/2 -translate-x-1/2 pb-3 pt-3 px-3 rounded-[20px] backdrop-blur-[50px] bg-[#252020]/30 animate-in slide-in-from-top-2 duration-150 z-[100]"
                style={{ 
                  bottom: '-6px',
                  border: '0.5px solid rgba(255, 255, 255, 0.1)', 
                  boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.2)',
                }}
              >
                <div className="flex flex-col items-center">
                  <div 
                    ref={volumeSliderRef}
                    className="relative w-1 h-20 bg-white/10 rounded-full cursor-pointer"
                    onMouseDown={handleVolumeMouseDown}
                  >
                    <div 
                      className="absolute bottom-0 w-1 bg-[#faf7f5] rounded-full"
                      style={{ height: `${volume}%` }}
                    />
                    <div 
                      className="absolute w-4 h-4 bg-[#faf7f5] rounded-full border-2 cursor-grab"
                      style={{ 
                        borderColor: colors.bg.primary,
                        bottom: `${volume}%`,
                        left: '50%',
                        transform: 'translate(-50%, 50%)'
                      }}
                    />
                  </div>
                  <div className="h-1" />
                  <button 
                    className="text-[#faf7f5] hover:opacity-80 transition-opacity"
                    onClick={handleMuteToggle}
                  >
                    <VolumeIcon isMuted={isMuted} />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Playbar;